import React, {useState} from "react";

import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import { Input } from "../../../../../../_metronic/_partials/controls";
import {SelectDropdown} from "../../../../../../_metronic/_partials/controls/forms/SelectDropdown";

const InvoiceEditSchema = Yup.object().shape({
    description: Yup.string(),
});

const InvoiceEditForm = ({ invoices, btnRef, saveInvoice }) => {
    const [branch, setBranch] = useState("");
    return (
        <>
            <Formik
                initialValues={invoices}
                onSubmit={(values) => saveInvoice({...values, branchId: branch})}
                validationSchema={InvoiceEditSchema}
                enableReinitialize={true}
            >
                {({ handleSubmit, setFieldValue, values }) => (
                    <>
                        {values && (
                            <Form className={"form form-label-right"}>
                                <div className={"form-group row"}>
                                    <div className={'col-lg-6'}>
                                        <Field
                                            name={"branchId"}
                                            component={SelectDropdown}
                                            label={"شعبه"}
                                            allowCreate={false}
                                            endpoint={"/branches"}
                                            selectedValues={values.branchName}
                                            onChange={(e) => {
                                                setBranch(e ?? null);
                                            }}
                                        />
                                    </div>
                                    <div className={"col-lg-8"}>
                                        <Field
                                            name={"description"}
                                            component={Input}
                                            label={"توضیحات"}
                                            type={"text"}
                                            useQuill={true}
                                        />
                                    </div>

                                </div>

                                <button
                                    type={"submit"}
                                    style={{ display: "none" }}
                                    ref={btnRef}
                                    onSubmit={() => handleSubmit()}
                                />
                            </Form>
                        )}
                    </>
                )}
            </Formik>
        </>
    );
};

export default InvoiceEditForm;
